import { UserShort } from '@/contracts/system-modules/auth/dto/user/UserShort'
import { EnumWorkspace, toWorkspace } from '@/contracts/system-modules/auth/enum/EnumWorkspace'

export class AuthResult {
  token: string
  expiresAt: string
  deviceUuid: string
  user: UserShort
  /** Заданы ли PIN учётной записи; false — нужен шаг «задайте PIN» */
  hasPins: boolean
  /** Рабочее место созданного устройства */
  workspace: EnumWorkspace

  constructor({ token, expiresAt, deviceUuid, user, hasPins, workspace }: {
    token: string, expiresAt: string, deviceUuid: string, user: { uuid: string, name: string }, hasPins?: boolean, workspace?: string
  }) {
    this.token = token
    this.expiresAt = expiresAt
    this.deviceUuid = deviceUuid
    this.user = new UserShort(user)
    this.hasPins = hasPins !== false
    this.workspace = toWorkspace(workspace)
  }
}
